import { Box, Typography } from '@mui/material';
import { Dialog } from '@components/dialog';
import { NON_LIVE_JURISDICTION_DIALOG_COPY } from './nonLiveJurisdiction';

type NonLiveJurisdictionDialogProps = {
  isOpen: boolean;
  isSubmitting: boolean;
  onCancel: () => void;
  onCreateAndDecline: () => void;
  onCreateInternalOnly: () => void;
};

export const NonLiveJurisdictionDialog = ({
  isOpen,
  isSubmitting,
  onCancel,
  onCreateAndDecline,
  onCreateInternalOnly,
}: NonLiveJurisdictionDialogProps) => (
  <Dialog
    open={isOpen}
    title={NON_LIVE_JURISDICTION_DIALOG_COPY.title}
    handleCloseDialog={onCancel}
    isCloseButtonDisabled={isSubmitting}
    primaryBtnText={NON_LIVE_JURISDICTION_DIALOG_COPY.declineOptionLabel}
    primaryBtnAction={onCreateAndDecline}
    isPrimaryBtnLoading={isSubmitting}
    isPrimaryBtnDisabled={isSubmitting}
    secondaryBtnText={NON_LIVE_JURISDICTION_DIALOG_COPY.cancelLabel}
    secondaryBtnAction={onCancel}
    isSecondaryBtnDisabled={isSubmitting}
    tertiaryBtnText={NON_LIVE_JURISDICTION_DIALOG_COPY.internalOnlyOptionLabel}
    tertiaryBtnAction={onCreateInternalOnly}
    tertiaryBtnLoading={isSubmitting}
    isTertiaryBtnDisabled={isSubmitting}
  >
    <Box sx={{ px: 4, py: 4 }}>
      <Typography variant='body2' fontWeight='normal'>
        {NON_LIVE_JURISDICTION_DIALOG_COPY.description}
      </Typography>
      <Typography variant='body2' fontWeight='normal' sx={{ mt: 2 }}>
        <strong>{NON_LIVE_JURISDICTION_DIALOG_COPY.declineOptionLabel}:</strong>{' '}
        {NON_LIVE_JURISDICTION_DIALOG_COPY.declineOptionDescription}
      </Typography>
      <Typography variant='body2' fontWeight='normal' sx={{ mt: 2 }}>
        <strong>{NON_LIVE_JURISDICTION_DIALOG_COPY.internalOnlyOptionLabel}:</strong>{' '}
        {NON_LIVE_JURISDICTION_DIALOG_COPY.internalOnlyOptionDescription}
      </Typography>
    </Box>
  </Dialog>
);
